import styled from 'styled-components';

export const TabsContentWrapper = styled.div`
  overflow: auto;
  max-height: calc(100vh - 240px);
`;
